<template>
    <div class="editform">
        <Form
            ref="actionLog"
            :model="actionLog"
            :label-width="90"
            :viewonly="isView"
        >
            <Row>
                <FormPartition title="当前进展">
                    <Row :gutter="20">
                        <Col span="12">
                            <FormItem label="执行人" prop="receiveUserName">
                                <Input
                                    v-model="actionLog.receiveUserName"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>

                        <Col span="12">
                            <FormItem
                                label="执行人电话"
                                prop="receiveUserMobile"
                            >
                                <Input
                                    v-model="actionLog.receiveUserMobile"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="当前操作" prop="actionTypeText">
                                <Input
                                    v-model="actionLog.actionTypeText"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem
                                label="当前操作对象"
                                prop="userIdentityTypeText"
                            >
                                <Input
                                    v-model="actionLog.userIdentityTypeText"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="20">
                            <FormItem label="当前操作说明" prop="content">
                                <Input
                                    v-model="actionLog.content"
                                    :maxlength="32"
                                    type="textarea"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="20">
                            <FormItem label="当前相关图片">
                                <div style="display: flex">
                                    <previewUpload
                                        v-model="actionLog.attachment"
                                    />
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="当前操作人" prop="actionUserName">
                                <Input
                                    v-model="actionLog.actionUserName"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem
                                label="当前操作人电话"
                                prop="actionUserMobile"
                            >
                                <Input
                                    v-model="actionLog.actionUserMobile"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem
                                label="当前操作时间"
                                prop="createTimeText"
                            >
                                <Input
                                    v-model="actionLog.createTimeText"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </FormPartition>

                <FormPartition title="动态轨迹">
                    <div class="approve-log">
                        <Timeline>
                            <TimelineItem
                                v-for="item in actionLogList"
                                :key="item.id"
                            >
                                <div style="font-weight: bold">
                                    {{ item.actionTypeText }}
                                </div>
                                <span style="margin-left: 6px">{{
                                    item.userIdentityTypeText +
                                    '[' +
                                    item.actionUserName +
                                    ' ' +
                                    item.actionUserMobile +
                                    ']' +
                                    item.createTimeText
                                }}</span>

                                <p style="padding-left: 8px">
                                    {{ item.content }}
                                </p>
                                <!--还有附件的展示-->
                                <div style="display: flex">
                                    <previewUpload v-model="item.attachment" />
                                </div>
                            </TimelineItem>
                        </Timeline>
                    </div>
                </FormPartition>
            </Row>
        </Form>
    </div>
</template>

<script>
import { ymdL } from '@/utils/helper'
import { Timeline, TimelineItem } from 'ivux'
import { getPublicImgUrls } from '@/utils/helper'
import previewUpload from '@/components/preview-upload'
import Dict from '_u/dict'

export default {
    name: 'orderProcess',
    components: {
        Timeline,
        TimelineItem,
        previewUpload,
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        formMode: {
            type: [String, Number],
            default: '',
        },
        workOrderEntity: {
            type: [Object],
            default: () => {},
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            actionLog: {
                actionUserName: '',
                actionUserMobile: '',
                providerUserName: '',
                providerUserMobile: '',
                actionType: '',
                userIdentityType: '',
                content: '',
                createUserName: '',
                createNameMobile: '',
                createTime: '',
                createTimeText: '',
                actionTypeText: '',
                userIdentityTypeText: '',
                attachment: '',
                receiveUserName: '',
                receiveUserMobile: '',
            },

            modalHeight: 600,
            modalWidth: 1000,

            isView: true,
            actionLogList: [],
        }
    },

    computed: {},
    methods: {},
    created() {
        this.loading = true
        Promise.all([Dict.get('user_base_type'), Dict.get('wo_action_type')])
            .then((args) => {
                var [userBaseType, actionType] = args
                var list = this.workOrderEntity.actionList

                //赋值动态轨迹
                this.actionLogList = list
                this.actionLogList.forEach((e) => {
                    e.actionTypeText = actionType.get(e.actionType).text
                    e.userIdentityTypeText = userBaseType.get(
                        e.userIdentityType
                    ).text
                    e.createTimeText = ymdL(e.createTime)
                })

                //赋值当前进展(固定排序后,取第一条或最后一条)
                if (list.length > 0) {
                    this.actionLog = list[list.length - 1]
                }

                //赋值执行人数据
                if (this.workOrderEntity.dispatchType == '1') {
                    this.actionLog.receiveUserName =
                        this.workOrderEntity.receiveInnerUserName
                    this.actionLog.receiveUserMobile =
                        this.workOrderEntity.receiveInnerUserMobile
                }

                if (this.workOrderEntity.dispatchType == '2') {
                    this.actionLog.receiveUserName =
                        this.workOrderEntity.receiveProviderUserName
                    this.actionLog.receiveUserMobile =
                        this.workOrderEntity.receiveProviderUserMobile
                }
            })
            .finally((this.loading = false))
    },
    mounted() {},
}
</script>

<style lang="less" scoped>
.card-img {
    width: 100px;
    height: 60px;
    cursor: pointer;
    margin: 0 6px;
}
.cip-gallery {
    height: 100px;
    box-sizing: border-box;
    padding: 10px 0;

    &-item {
        width: 100px;
        height: 100px;
        margin-right: 10px;
        cursor: pointer;
    }
}
.approve-log {
    margin: 12px 0 0 12px;
    max-height: 210px;
    overflow-y: auto;
}
</style>
